/* src/app/shared/dialogs/journey-door-unlock-cases-dialog/journey-door-unlock-cases-dialog.component.scss */
:host {
  overflow: none;
}
.dialog-container {
  width: 530px;
  position: relative;
}
.dialog-container h1 {
  font-size: 18px;
  font-weight: bold;
  line-height: 0.83;
  text-align: left;
  margin: 0;
  margin-top: 8px;
}
.dialog-container p {
  font-size: 16px;
  line-height: 1.19;
  letter-spacing: 0.1px;
  text-align: left;
  margin-top: 32px;
}
.dialog-container .button-cancel {
  position: absolute;
  right: 0;
  top: 0;
}
.dialog-container .dialog-info {
  margin-top: 32px;
}
.dialog-container .dialog-actions {
  margin-bottom: 0px;
  margin-top: 32px;
}
.dialog-container .dialog-actions button {
  margin-left: auto;
  margin-right: auto;
}
.dialog-container .dialog-content {
  overflow-y: auto;
  overflow-x: auto;
  max-height: 650px;
}
/*# sourceMappingURL=journey-door-unlock-cases-dialog.component.css.map */
